// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__YXMvC","listItem":"styles_listItem__O+7tD"};